<template>
<div class="popup" v-cloak v-if="cancelAllShow">
    <div class="content" id="cancelAll">
        <div class="title">
            <span>{{$t('language.popup.cancel')}}</span>
            <div class="icon white-close dialog-close" @click="closePage()"></div>
        </div>
        <div class="cancel-all-content">
            <span>{{$t('language.popup.cloudExploerPopup.cancelAllTask')}}</span>
        </div>
        <div class="cancel-all-footer">
            <button v-if="!loading" style="float:right;min-width:82Px;" @click="cancelAll()"><span>{{$t('language.popup.cancel')}}</span></button>
            <button v-if="loading" style="float:right;min-width:82Px;" ><span v-loading='loading'></span></button>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
export default {
    data: function () {
        return {
            cancelAllShow: false,
            snapDataNum: 0,
            loading: false,
            time: 0, //运行次数
        }
    },
    watch: {
        '$store.state.retryItems': function (newValue, oldValue) {
            if (!newValue.length) {
                this.cancelAllShow = false;
            }
        }
    },
    methods: {
        //关闭弹窗
        closePage() {
            this.cancelAllShow = false;
        },
        //清除所有临时任务
        cancelAll() {
            let that = this;
            let allData = Object.assign([], that.$store.state.retryItems);
            //如果临时任务里面包含上传任务，则取消上传任务
            if(that.$store.state.uploadArr.length){
                $.each(that.$store.state.uploadArr,function(i,item){
                      if (item.uploadStart) {
                        that.$emit("cancel", item.name);
                }
                });
                //如果界面中的任务全部都是上传任务，此时用户进行取消
                if(that.$parent.$refs.snapTaskDialog.items.length==that.$store.state.uploadArr.length){
                 that.$store.state.uploadArr=[];
                 that.cancelAllShow = false;
                 that.$parent.uploadFlag=true;
                 return false;
                 }
            }
            //取消全部数据
            let cancelAllData=new cloudExploerUtils.cancelAllData(commonUtils.getUserToLocal().id,4,true);
            that.loading=true;
            //调用清除接口
            this.Utils.doTasksRequest('cancel', cancelAllData).then(response => {
                if (response.status == 200) {
                    that.loading=false;
                    //成功后清空数据
                    that.$store.state.retryItems = [];
                    that.$store.state.uploadArr=[];
                    $.each(that.$store.state.detailedProgrssData, function (index, taskItem) {
                            if (taskItem.status<3) {//如果任务状态为待执行，设置状态为取消
                                taskItem.status = 3;
                                 that.$store.state.detailTabUnfinished.push(taskItem);
                                if (taskItem.itemProgressInfo) {
                                    taskItem.itemProgressInfo.status = 3;
                                    delete taskItem.itemProgressInfo.percent;
                                    delete taskItem.itemProgressInfo.speed;
                                }
                                that.$forceUpdate();
                            }
                        });
                }else if(response.reason=='noTaskRunning'){//如果此时没有正在运行的数据，清空数据
                    that.$store.state.retryItems = [];
                    that.$store.state.uploadArr=[];
                     that.loading=false;
                }
            });
           
        },
    }
}
</script>

<style>
#cancelAll {
    width: 400px;
    /*no*/
    height: 200px;
    /*no*/
}

.cancel-all-content {
    width: 100%;
    /*no*/
    height: 90px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
    line-height: 20px;/*no*/
    padding-top: 35px;/*no*/
}

.cancel-all-footer {
    width: 100%;
    height: 48px;
    /*no*/
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
}


#cancelAll .el-loading-spinner .path {
    stroke: #fff !important;
}
#cancelAll .el-loading-spinner {
    position: relative;
    top: 9px;
    /*no*/
    left: -12px;
    /*no*/
}

#cancelAll .el-loading-spinner i {
    color: #fff;
}
#cancelAll .el-loading-spinner {
    font-size: 15px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/cancel_all_popup.vue